import * as React from 'react';
import { VrPropertySummaryViewModel } from 'models/hotel/hotel-details-types';

export interface PropertySummaryProps {
  singleUnitVrPropertySummary?: VrPropertySummaryViewModel;
}

export const PropertySummary: React.FunctionComponent<PropertySummaryProps> = ({ singleUnitVrPropertySummary }) => {
  const { sleepGuestCountText, bedroomCountText, bathroomCountText } = singleUnitVrPropertySummary;
  const contentPadding = 'uitk-cell all-cell-shrink all-r-padding-three uitk-type-subheading';

  return (
    <div data-stid="single-unit-vr-property-summary" className="uitk-grid uitk-cell all-cell-fill all-b-padding-one all-t-padding-one">
      {sleepGuestCountText && <div className={contentPadding}>{sleepGuestCountText}</div>}
      {bedroomCountText && <div className={contentPadding}>{bedroomCountText}</div>}
      {bathroomCountText && <div className={contentPadding}>{bathroomCountText}</div>}
    </div>
  );
};
